var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', [_vm._v(" 報表中心 ")]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'PushedMessageList'
      }
    }
  }, [_vm._v(" LINE 推播紀錄 ")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(_vm._s(_vm.title))])], 1)], 1)])]), _c('b-form', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', {
    attrs: {
      "title": _vm.title
    }
  }, [_c('b-card-body', [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    staticClass: "col-12 col-sm-12 col-lg-12",
    attrs: {
      "label": "Message"
    }
  }, [_c('jsonEditor', {
    attrs: {
      "height": "200px",
      "readonly": "readonly"
    },
    model: {
      value: _vm.pushedMessage.message,
      callback: function callback($$v) {
        _vm.$set(_vm.pushedMessage, "message", $$v);
      },
      expression: "pushedMessage.message"
    }
  })], 1), _vm._l(_vm.templates, function (template, index) {
    return _c('b-row', {
      key: index
    }, [_c('b-form-group', {
      staticClass: "col-12 col-sm-6 col-lg-3",
      attrs: {
        "label": "Live Preview"
      }
    }, [_c('div', {
      staticClass: "p-2",
      staticStyle: {
        "background-color": "#849ebf"
      }
    }, [_c('div', {
      attrs: {
        "id": "preview"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.lineFlexCard(template))
      }
    })])]), _c('b-form-group', {
      staticClass: "col-12 col-sm-6 col-lg-9",
      attrs: {
        "label": "Value"
      }
    }, [_c('editor', {
      attrs: {
        "width": "100%",
        "height": "200px",
        "lang": "json",
        "theme": "chrome"
      },
      on: {
        "init": _vm.editorInit
      },
      model: {
        value: template.value,
        callback: function callback($$v) {
          _vm.$set(template, "value", $$v);
        },
        expression: "template.value"
      }
    })], 1)], 1);
  }), _c('b-row', {
    staticClass: "my-3"
  }, [_c('b-col', [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("返回")])], 1)], 1)], 2)], 1)], 1)], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }